import "./Quote.scss";
import Button from "../../components/shared/Button";
import { ArrowRight } from "iconsax-react";

export default function Quote() {
	return (
		<>
			<div className="quote">
				<div className="quote-content-wrapper content-wrapper-lg">
					<div className="quote-text" data-aos="zoom-out-up">
						Alligators are known for their ability to move through
						water{" "}
						<span className="highlight">
							without making a ripple.
						</span>
					</div>

					<div className="quote-btns" data-aos="fade-up">
						<Button className="quote-btn" href="https://atlas-20.gitbook.io/gatr/">
							Get Started
							<ArrowRight
								className="btn-icon"
								size="19"
								color="#000000"
							/>
						</Button>
					</div>
				</div>
			</div>
		</>
	);
}
